module.exports = __webpack_public_path__ + "static/media/8.88ebb2c6.jpg";